import { createSelector } from '@reduxjs/toolkit';
import prop from 'lodash/fp/prop';
import { selectUserAccountId } from 'user/api/selectors';

import { eventApi } from './eventApi';

import type { RootState } from 'store';

const selectEventDetailsById = eventApi.endpoints.getEventDetails.select;

const selectActiveEventId = (state: RootState) => state.event.activeEventId!;

// Memoize the args object to ensure stable reference for RTK Query selectors
const selectEventDetailsArgs = createSelector([selectActiveEventId], (activeEventId) => ({ id: activeEventId }));

const selectEventQuestionsArgs = createSelector([selectActiveEventId], (activeEventId) => ({ id: activeEventId }));

// TODO Replace with `selectEventDetailsById` only when event hash migration finished
export const selectActiveEventDetails = createSelector(
  [selectEventDetailsArgs, (state: RootState) => state],
  (args, state) => {
    const result = selectEventDetailsById(args)(state);
    return result?.data;
  }
);

export const selectActiveEventQuestions = createSelector(
  [selectEventQuestionsArgs, (state: RootState) => state],
  (args, state) => {
    const result = eventApi.endpoints.getEventQuestions.select(args)(state);
    return result?.data;
  }
);

export const selectIsUserRegistered = createSelector(selectActiveEventDetails, prop('isUserRegistered'));

export const selectHasCompletedPreEventQuestions = createSelector(
  selectActiveEventDetails,
  prop('hasCompletedPreEventQuestions')
);

export const selectHasCompletedPostEventQuestions = createSelector(
  selectActiveEventDetails,
  prop('hasCompletedPostEventQuestions')
);

export const selectEventStatus = createSelector(selectActiveEventDetails, prop('status'));

export const selectEventName = createSelector(selectActiveEventDetails, prop('name'));

export const selectEventPin = createSelector(selectActiveEventDetails, prop('pin'));
export const selectEventPinEnabled = createSelector(selectActiveEventDetails, prop('isPinEnabled'));
export const selectEventCommunityId = createSelector(selectActiveEventDetails, prop('communityId'));
/** Use when want to omit host's privileges */
export const selectIsEventOwner = createSelector(
  selectActiveEventDetails,
  selectUserAccountId,
  (event, userId) => event?.owner.id === userId
);
